import { PrincipalContainer } from "./PrincipalContainer";

export default PrincipalContainer;
